(function ($) {
    function init(plot) {
        plot.hooks.draw.push(function (plot, ctx) {
            var options = plot.getOptions();
            var legendContainer = options.legend.container;
            var legendTable;

            if (legendContainer) {
                legendTable = $(legendContainer).find('table');
            } else {
                legendTable = plot.getPlaceholder().find('.legend table');
            }

            legendTable.attr('role', 'presentation');
        });
    }

    $.plot.plugins.push({
        init: init,
        name: 'accessibility',
        version: '1.0'
    });
})(jQuery);
